import { defineStore } from "pinia";

export interface NavItem {
  id: string;
  name: string;
  slug: string;
  path: string;
  titleDescription?: string;
  children: NavItem[];
}

export const useNavigationStore = defineStore("navigation", () => {
  const items = ref<NavItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const fetchNavigation = async () => {
    if (items.value.length > 0) return;
    try {
      loading.value = true;
      error.value = null;
      const api = useApi();
      const response = await api<any>("/api/navigation");
      items.value = response.categories || [];
    } catch (err: any) {
      error.value =
        err.data?.message ||
        err.message ||
        "Navigation konnte nicht geladen werden";
    } finally {
      loading.value = false;
    }
  };

  return {
    items,
    loading,
    error,
    fetchNavigation,
  };
});
